import { asIfAccessToken } from '@/features/as-if/asIfView';
import {
  deploymentCredentialSlots,
  effectiveDeploymentAddress,
} from '@/features/onboarding/deploymentAddress';

/**
 * F-0709 ASIF-12 / ASIF-29: the one place the person's access token slot is read for anything but the
 * session's own upkeep. A tab holding an as-if view speaks with the view's credential, never the
 * person's, so each reader below says which it wants:
 *
 * - `requestAccessToken()`: whatever this tab speaks with, the view's token while a view is held.
 *   For a request that carries what the page shows (the realtime socket, a write that outlives the page).
 * - `personalAccessToken()`: the person's own token, and none while a view is held. For what is the
 *   person's alone and has no view of its own (the attention count, the personal stream, push, the
 *   device's keys): under a view those are off.
 * - `ownAccessToken()`: the person's own token even under a view, for the credential's own lifecycle
 *   (is a session held, sign out, the desktop refresher). Never for a request that shows data.
 *
 * `accessToken.guard.test.ts` fails on any other file that names `TOKEN_KEY`, except those listed
 * there with a reason.
 */
const credentialSlots = deploymentCredentialSlots(effectiveDeploymentAddress());
export const TOKEN_KEY = credentialSlots.tokenKey;
export const REFRESH_KEY = credentialSlots.refreshKey;

/** The person's own token, whatever view is held. May throw where storage is blocked, as a read does. */
export function ownAccessToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function requestAccessToken(): string | null {
  return asIfAccessToken() ?? ownAccessToken();
}

export function personalAccessToken(): string | null {
  return asIfAccessToken() === null ? ownAccessToken() : null;
}
